import React from 'react'
import { useDispatch } from 'react-redux'
import GridData from '../../components/GridData/GridData'
import PrintersApp, { IPrinterJobModel } from './PrintersApp'
import { IDataDisplayerPagination } from '../../components/DataDisplayer/DataDisplayer'
import { ISearchParam } from '../BaseApp'

interface IProps {
    printerId: number,
}

export default function PrinterJobsList(props: IProps) {

    const dispatch = useDispatch()

    const {
        printerId
    } = props

    const printersApp = new PrintersApp()

    const [jobs, setJobs] = React.useState<IPrinterJobModel[]>([])
    const [selectedJobs, setSelectedJobs] = React.useState<IPrinterJobModel[]>([])
    const [loading, setLoading] = React.useState<boolean>(true)
    const [pagination, setPagination] = React.useState<IDataDisplayerPagination>({
        count: 0,
        current_page: 0,
        total_pages: 0
    })
    const [search, setSearch] = React.useState<string>("")
    const [searchParams, setSearchParams] = React.useState<ISearchParam[]>([])

    const handleLoadJobs = (
        page: number, 
        search: string | null, 
        disablePagination: boolean, 
        addItems?: boolean, 
        searchParams?: ISearchParam[]
    ) => printersApp.printerJobsList(printerId, page, search, disablePagination, addItems, searchParams)

    return(
        <div>
            <GridData 
                items={jobs}
                selectedItems={selectedJobs}
                columns={[
                    {
                        field: "status",
                        headerName: "Status",
                        type: "status",
                        minWidth: 100,
                        width: 100
                    },
                    {
                        field: "printer_title",
                        headerName: "Printer",
                        type: "text",
                        minWidth: 250
                    },
                    {
                        field: "printed_by",
                        headerName: "Printed by",
                        type: "text",
                        minWidth: 250
                    },
                    {
                        field: "claimed_at",
                        headerName: "Claimed at",
                        type: "date",
                        minWidth: 230
                    },
                    {
                        field: "printed_at",
                        headerName: "Printed at",
                        type: "date",
                        minWidth: 230
                    },
                     {
                        field: "error",
                        headerName: "Error",
                        type: "text",
                        minWidth: 250
                    },
                ]}
                pagination={pagination}
                search={search}
                searchParams={searchParams}
                loading={loading}
                actionButtons={[]}
                headerOptions={[]}
                handleLoadItems={handleLoadJobs}
                updateSearch={(search) => setSearch(search)}
                setSelectedItems={(items) => setSelectedJobs(items)}
                onDeleteItem={printersApp.deletePrinterJob}
                onDeleteManyItems={printersApp.deleteManyPrinterJobs}
                deleteItem={(id, dispatch) => {}}
                updateLoading={(status) => setLoading(status)}
                updateItemSearchParams={(params) => setSearchParams(params)}
                addNewItem={(item, dispatch) => {}}
                updateItem={(item, dispatch) => {}}
                updateAllItems={(items, dispatch) => setJobs(items)}
                updateItemsPagination={(pagination, dispatch) => setPagination(pagination)}
                config={{
                    viewItemLink: "",
                    editItemLink: "",
                    disableDelete: true,
                    disableActionButtons: true,
                    disableSelect: true,
                }}
            />
        </div>
    )
}